export interface Article {
  id: string
  title: string
  excerpt: string
  content: string
  category: string
  categoryName: string
  coverImage: string
  rating: number
  views: number
  tags: string[]
  publishDate: string
  author: string
  featured: boolean
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2024年度色里番TOP10精选推荐 — 不可错过的年度佳作',
    excerpt: '盘点2024年度最值得观看的色里番作品，从制作精良到剧情深刻，这份榜单涵盖了今年最具代表性的优质作品。',
    content: `<p>2024年是色里番行业蓬勃发展的一年，众多优秀作品层出不穷。本文将为您盘点本年度最值得观看的TOP10色里番作品，希望能帮助您在浩瀚的作品海洋中找到真正值得花时间欣赏的佳作。</p>
<h2>评选标准</h2>
<p>本次评选综合考虑了以下几个维度：制作质量（画风、分镜、配音）、剧情深度、角色塑造、用户口碑以及整体完成度。每部作品都经过团队多次讨论和评审，力求客观公正。</p>
<h2>TOP 1：暗影诗篇</h2>
<p>这部作品以其精美的画面和深刻的剧情脱颖而出。故事讲述了一个关于救赎与成长的动人故事，画面表现力极强，每一帧都可以截图当壁纸。角色设计细腻，情感表达到位，是今年当之无愧的年度最佳。</p>
<h2>TOP 2：星海迷途</h2>
<p>科幻题材的色里番作品不多见，但《星海迷途》做到了极致。宏大的世界观设定、精致的机械设计、以及充满张力的剧情推进，让这部作品在科幻爱好者中获得了极高的评价。</p>
<h2>TOP 3：花间秘语</h2>
<p>一部以唯美画风著称的作品，讲述了一段跨越时空的浪漫故事。画面用色柔和细腻，音乐搭配恰到好处，整体氛围营造非常出色。适合喜欢温馨浪漫风格的观众。</p>
<h2>总结</h2>
<p>以上就是2024年度色里番TOP10的精选推荐。每一部作品都有其独特的魅力和价值，建议根据自己的喜好选择性观看。我们将持续关注行业动态，为您带来更多优质推荐。</p>`,
    category: 'hot',
    categoryName: '热门推荐',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20with%20dramatic%20lighting%2C%20dark%20atmospheric%20scene%20with%20cherry%20blossom%20petals%2C%20elegant%20character%20silhouette%2C%20cinematic%20composition%2C%20warm%20and%20mysterious%20mood%2C%20high%20quality%20digital%20art%2C%20soft%20gradients%20and%20rich%20contrast%2C%20anime%20aesthetic%20wallpaper%20style&width=800&height=450&seq=article-cover-1&orientation=landscape',
    rating: 9.5,
    views: 128500,
    tags: ['年度推荐', 'TOP10', '精选', '排行'],
    publishDate: '2024-12-15',
    author: '编辑部',
    featured: true,
  },
  {
    id: 'article-2',
    title: '新番速递：2025年1月冬季新番色里番前瞻指南',
    excerpt: '2025年冬季新番即将上线，我们为您整理了本月最值得期待的色里番新作，提前了解即将到来的精彩内容。',
    content: `<p>2025年1月冬季新番季节即将到来，多部备受期待的色里番新作蓄势待发。本期新番速递为您带来最全面的冬季新番前瞻指南。</p>
<h2>最受期待新作</h2>
<p>本季新番阵容强大，多部知名系列推出续作，同时也有不少原创作品首次亮相。以下是编辑部精选的本季最值得关注的新番作品。</p>
<h2>续作回归</h2>
<p>多部人气系列的续作将在本季回归，包括《暗夜幻想录 第二季》和《极乐境界 终章》。这些续作在前作的基础上进行了全面升级，画面质量和剧情深度都有显著提升。</p>
<h2>原创首发</h2>
<p>本季还有多部原创作品值得关注。《镜中花》以其独特的美术风格吸引了大量关注，《夜行录》则凭借新颖的题材设定成为话题之作。</p>
<h2>观看建议</h2>
<p>建议根据个人喜好选择性追番，不必贪多。关注我们的后续详细评测，帮助您做出最佳选择。</p>`,
    category: 'new',
    categoryName: '新番速递',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20winter%20scene%20with%20snowflakes%2C%20warm%20indoor%20lighting%2C%20cozy%20atmosphere%2C%20Japanese%20anime%20aesthetic%2C%20soft%20blue%20and%20warm%20orange%20color%20palette%2C%20digital%20art%2C%20cinematic%20lighting%2C%20high%20detail&width=800&height=450&seq=article-cover-2&orientation=landscape',
    rating: 8.8,
    views: 89500,
    tags: ['新番', '冬季', '前瞻', '指南'],
    publishDate: '2024-12-28',
    author: '新番观察组',
    featured: true,
  },
  {
    id: 'article-3',
    title: '经典回顾：《暗夜幻想录》— 一部改变色里番格局的里程碑之作',
    excerpt: '深度解析《暗夜幻想录》这部经典色里番作品的艺术价值与行业影响，回顾它如何重新定义了整个品类的创作标准。',
    content: `<p>在色里番的发展史上，《暗夜幻想录》是一部绕不开的里程碑作品。自发布以来，它不仅获得了极高的用户评价，更在行业内产生了深远的影响。</p>
<h2>作品背景</h2>
<p>《暗夜幻想录》由知名工作室历时三年精心打造，投入了大量资源和心血。制作团队汇集了业内顶尖的画师、编剧和声优，力求在每个细节上都做到极致。</p>
<h2>艺术成就</h2>
<p>这部作品最令人称道的是其卓越的画面表现力。每一帧画面都经过精心构图，光影运用出神入化，色彩搭配极具美学价值。角色设计既有日式传统美学的底蕴，又融入了现代审美元素。</p>
<h2>剧情深度</h2>
<p>与大多数同类作品不同，《暗夜幻想录》拥有一个完整而深刻的故事线。它探讨了人性、欲望、救赎等深刻主题，在娱乐性之外还提供了思考的空间。</p>
<h2>行业影响</h2>
<p>《暗夜幻想录》的成功证明了一个道理：高品质的内容永远有市场。它的出现促使更多制作方开始重视作品质量，推动了整个行业的良性发展。</p>
<h2>为什么值得重温</h2>
<p>即使多年过去，这部作品的画面和剧情依然具有强大的感染力。每次重温都会有新的发现和感悟，这正是经典的魅力所在。</p>`,
    category: 'classic',
    categoryName: '经典回顾',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20style%20illustration%2C%20gothic%20castle%20silhouette%20under%20moonlight%2C%20dramatic%20contrast%2C%20mysterious%20atmosphere%2C%20elegant%20composition%2C%20high%20quality%20digital%20painting%2C%20rich%20dark%20tones%20with%20warm%20accents&width=800&height=450&seq=article-cover-3&orientation=landscape',
    rating: 9.7,
    views: 215000,
    tags: ['经典', '深度解析', '里程碑', '回顾'],
    publishDate: '2024-11-20',
    author: '深度评测组',
    featured: true,
  },
  {
    id: 'article-4',
    title: '色里番入坑指南：新手必看的10部入门级推荐作品',
    excerpt: '刚接触色里番不知道从哪开始？这份新手向推荐清单帮你快速找到适合自己的入门作品，轻松开启色里番之旅。',
    content: `<p>如果你刚刚接触色里番的世界，面对海量的作品可能会感到无从下手。别担心，这份专门为新手准备的入坑指南将帮助你轻松入门。</p>
<h2>新手选择原则</h2>
<p>对于初次接触色里番的观众，我们建议从以下几个角度选择作品：画风舒适、剧情易懂、篇幅适中、口碑良好。以下推荐的作品都经过了大量新用户的验证，是公认的优秀入门之选。</p>
<h2>推荐清单</h2>
<p>以下10部作品按照推荐优先级排列，每部都附有简短的介绍和适合人群说明，帮助您快速做出选择。</p>
<h2>观看建议</h2>
<p>建议从排名靠前的作品开始观看，逐步建立自己的审美偏好。不必追求一次性看完所有推荐作品，享受过程才是最重要的。</p>`,
    category: 'hot',
    categoryName: '热门推荐',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20warm%20and%20inviting%20illustration%2C%20colorful%20vibrant%20scene%20with%20soft%20lighting%2C%20beginner%20friendly%20welcoming%20atmosphere%2C%20cherry%20blossom%20and%20gentle%20sunlight%2C%20digital%20art%2C%20clean%20composition&width=800&height=450&seq=article-cover-4&orientation=landscape',
    rating: 9.2,
    views: 76500,
    tags: ['新手', '入坑', '指南', '入门'],
    publishDate: '2024-12-05',
    author: '编辑部',
    featured: false,
  },
  {
    id: 'article-5',
    title: '2024年12月色里番月度排行榜 — 本月最受欢迎作品一览',
    excerpt: '最新月度排行榜出炉，看看哪些色里番作品在本月获得了最高的用户评价和观看量，发现当下最热门的内容。',
    content: `<p>2024年12月的色里番月度排行榜新鲜出炉！本月有多部新作上榜，也有一些经典作品持续霸榜，让我们一起来看看详细排名。</p>
<h2>榜单概览</h2>
<p>本月榜单呈现出新老交替的态势，多部新番凭借出色的品质成功上榜，同时几部经典作品依然保持着强劲的竞争力。</p>
<h2>排名分析</h2>
<p>本月排名第一的作品在画风和剧情上都达到了极高的水准，获得了用户的一致好评。排名变化反映了当前用户的审美趋势和内容偏好。</p>
<h2>趋势解读</h2>
<p>从本月榜单可以看出，用户对作品的要求越来越高，单纯依靠噱头已经无法获得高排名。制作精良、剧情扎实的作品更容易获得用户认可。</p>`,
    category: 'ranking',
    categoryName: '排行榜',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20ranking%20chart%20illustration%2C%20podium%20with%20trophy%2C%20competitive%20award%20ceremony%20theme%2C%20dramatic%20spotlight%20and%20stage%20lighting%2C%20gold%20silver%20bronze%20color%20scheme%2C%20digital%20art%2C%20celebratory%20atmosphere&width=800&height=450&seq=article-cover-5&orientation=landscape',
    rating: 8.5,
    views: 156000,
    tags: ['月度排行', '排行', '热门', '12月'],
    publishDate: '2025-01-01',
    author: '数据分析组',
    featured: false,
  },
  {
    id: 'article-6',
    title: '色里番系列作品合集推荐 — 一网打尽优质长篇系列',
    excerpt: '整理最值得追的色里番系列作品合集，从长篇连续作品到经典三部曲，为您节省搜索时间，直接享受高品质内容。',
    content: `<p>对于喜欢追系列作品的观众来说，找到一个品质稳定的长篇系列是最大的幸福。本文为大家整理了当前最值得关注的色里番系列作品合集。</p>
<h2>系列推荐</h2>
<p>以下推荐的系列作品均具有完整的叙事线和稳定的制作质量，适合想要沉浸式观看体验的观众。</p>
<h2>观看顺序</h2>
<p>每个系列我们都标注了推荐的观看顺序，确保您能获得最佳的观看体验。部分系列存在多个观看顺序，我们标注的是最主流的方式。</p>`,
    category: 'collection',
    categoryName: '精选合集',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20collection%20display%2C%20multiple%20illustration%20panels%20arranged%20artistically%2C%20library%20or%20archive%20theme%2C%20organized%20aesthetic%2C%20warm%20wooden%20tones%2C%20digital%20art%2C%20clean%20and%20elegant%20layout&width=800&height=450&seq=article-cover-6&orientation=landscape',
    rating: 9.0,
    views: 98200,
    tags: ['合集', '系列', '长篇', '整理'],
    publishDate: '2024-11-28',
    author: '内容整理组',
    featured: false,
  },
  {
    id: 'article-7',
    title: '深度评测：《星海迷途》— 科幻色里番的天花板之作',
    excerpt: '全方位深度评测《星海迷途》，从画面、剧情、音乐到角色塑造，解析这部科幻色里番为何能获得如此高的评价。',
    content: `<p>《星海迷途》自上线以来就获得了极高的关注度和评价。本文将从多个维度对这部作品进行深度评测，帮助您全面了解它的魅力所在。</p>
<h2>世界观设定</h2>
<p>《星海迷途》构建了一个宏大而自洽的科幻世界观。从星际文明的兴衰到个体的命运抉择，每个设定都经过精心设计，相互关联，构成了一个令人沉浸的宇宙。</p>
<h2>画面与技术</h2>
<p>作为科幻题材，作品在视觉呈现上投入了大量资源。太空场景的宏大与细腻兼具，机械设计兼具美感与合理性。光影效果和粒子特效的运用更是达到了业界顶尖水准。</p>
<h2>角色与配音</h2>
<p>角色塑造立体丰满，每个角色都有自己独特的性格弧线和成长轨迹。配音演员的表现同样出色，将角色的情感层次诠释得淋漓尽致。</p>
<h2>音乐与音效</h2>
<p>配乐由知名作曲家操刀，将科幻的冷峻与人性的温暖完美融合。音效设计同样用心，增强了观看的沉浸感。</p>`,
    category: 'hot',
    categoryName: '热门推荐',
    coverImage: 'https://readdy.ai/api/search-image?query=Sci%20fi%20anime%20style%20illustration%2C%20futuristic%20spaceship%20and%20nebula%20background%2C%20cosmic%20deep%20space%20scene%2C%20dramatic%20blue%20and%20purple%20galaxy%2C%20high%20quality%20digital%20art%2C%20cinematic%20composition%2C%20epic%20scale&width=800&height=450&seq=article-cover-7&orientation=landscape',
    rating: 9.4,
    views: 187000,
    tags: ['深度评测', '科幻', '解读', '推荐'],
    publishDate: '2024-12-10',
    author: '深度评测组',
    featured: true,
  },
  {
    id: 'article-8',
    title: '画风精美的色里番作品推荐 — 每一帧都是壁纸级别的视觉盛宴',
    excerpt: '精心挑选画风最为出色的色里番作品，从细腻的人物描绘到宏大的场景构建，为您呈现视觉上的极致享受。',
    content: `<p>在色里番的世界中，画风是决定第一印象的关键因素。本文精选了画风最为出色的作品，每一部都能带给您视觉上的极致享受。</p>
<h2>画风类型解析</h2>
<p>色里番的画风多种多样，从唯美细腻到粗犷写实，各有各的魅力。本文将帮助您了解不同画风的特点，找到自己喜欢的视觉风格。</p>
<h2>精选推荐</h2>
<p>以下作品在画风方面都达到了极高水准，无论是人物设计、场景绘制还是色彩运用，都堪称教科书级别的示范。</p>`,
    category: 'genre',
    categoryName: '类型分类',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20art%20style%20illustration%2C%20elegant%20and%20detailed%20character%20design%2C%20soft%20pastel%20color%20palette%2C%20decorative%20floral%20elements%2C%20refined%20aesthetic%2C%20high%20quality%20digital%20painting%2C%20wallpaper%20worthy%20composition&width=800&height=450&seq=article-cover-8&orientation=landscape',
    rating: 9.1,
    views: 134000,
    tags: ['画风', '精美', '视觉', '推荐'],
    publishDate: '2024-11-15',
    author: '美术评测组',
    featured: false,
  },
]

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug)
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured)
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id)
}

export function getHotArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, limit)
}

export function getLatestArticles(limit: number = 4): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit)
}